import { useEffect } from 'react';

const PrintProtection = () => {
    useEffect(() => {
        // Disable print shortcuts (Ctrl+P, Cmd+P)
        const handleKeyDown = (e) => {
            // Prevent Ctrl+P / Cmd+P
            if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
                e.preventDefault();
                alert('Printing is disabled for this application.');
                return false;
            }

            // Prevent Ctrl+S / Cmd+S (Save)
            if ((e.ctrlKey || e.metaKey) && e.key === 's') {
                e.preventDefault();
                alert('Saving is disabled. Your data is automatically saved to the server.');
                return false;
            }

            // Prevent Print Screen key
            if (e.key === 'PrintScreen') {
                e.preventDefault();
                alert('Screenshots are discouraged for privacy protection.');
                return false;
            }
        };

        // Prevent right-click context menu
        const handleContextMenu = (e) => {
            e.preventDefault();
            return false;
        };

        // Detect and prevent browser print dialog
        const handleBeforePrint = (e) => {
            e.preventDefault();
            alert('Printing is disabled for this application to protect your privacy.');
            return false;
        };

        // Add event listeners
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('contextmenu', handleContextMenu);
        window.addEventListener('beforeprint', handleBeforePrint);

        // Disable copy-paste for sensitive areas
        const handleCopy = (e) => {
            if (e.target.closest('.journal-container, .self-assessment-container')) {
                e.preventDefault();
                return false;
            }
        };

        document.addEventListener('copy', handleCopy);
        document.addEventListener('cut', handleCopy);

        // Add watermark to discourage screenshots
        // const addWatermark = () => {
        //     const watermark = document.createElement('div');
        //     watermark.id = 'privacy-watermark';
        //     watermark.style.cssText = `
        //         position: fixed;
        //         top: 50%;
        //         left: 50%;
        //         transform: translate(-50%, -50%) rotate(-45deg);
        //         font-size: 60px;
        //         color: rgba(154, 140, 140, 0.03);
        //         pointer-events: none;
        //         z-index: 9999;
        //         white-space: nowrap;
        //         user-select: none;
        //     `;
        //     watermark.textContent = 'CONFIDENTIAL';
        //     document.body.appendChild(watermark);
        // };

        // addWatermark();

        // Cleanup
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('contextmenu', handleContextMenu);
            window.removeEventListener('beforeprint', handleBeforePrint);
            document.removeEventListener('copy', handleCopy);
            document.removeEventListener('cut', handleCopy);

            const watermark = document.getElementById('privacy-watermark');
            if (watermark) {
                watermark.remove();
            }
        };
    }, []);

    return null;
};

export default PrintProtection;
